import { Link } from 'react-router-dom';
import { Card, CardBody, EmptyState } from '../components/Card';

export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-0 p-6 text-fg">
      <Card className="w-full max-w-md">
        <CardBody>
          <EmptyState
            title="页面不存在"
            description="你访问的地址没有对应的页面，可能是链接已失效。"
            action={
              <Link to="/" className="text-sm font-medium text-accent hover:underline">
                返回主页
              </Link>
            }
          />
        </CardBody>
      </Card>
    </div>
  );
}
